module.exports = __webpack_public_path__ + "img/hw.7bb505c2.jpg";